(function () {
    'use strict';

    angular
        .module('travelControllers')
        .controller('TravelGovernanceProcessEditController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'topBarService', 'notificationService', 'fiscalYears', 'governanceProcess', 'govProcessType', 'travelService'];

    function Controller($rootScope, $scope, $state, topBarService, notificationService, fiscalYears, governanceProcess, govProcessType, travelService) {
        topBarService.setTitleAndIcon('Travel Governance Process Management', 'fa fa-plane');

        $scope.fiscalYears    = fiscalYears;
        $scope.govProcess     = governanceProcess;
        $scope.govProcessType = govProcessType
        $scope.isSubmitting   = false;

        $scope.goToGovernanceProcessList = function (replace) {
            $state.go('travel.governanceProcessActive', {replace: replace});
        };

        if ($state.is('travel.governanceProcessEdit') && !governanceProcess) {
            notificationService.warn('Couldn\'t find Governance Process or Governance Process is closed.');
            $scope.goToGovernanceProcessList(true);
        }
        /*
        if ($scope.govProcess.GovernanceProcessID && !$scope.govProcess.IsActive) {
            // Prevent editing closed gov processes
            $scope.goToGovernanceProcessList(true);
        }
        */
        if ($scope.govProcess.StartDate) $scope.govProcess.StartDate = moment($scope.govProcess.StartDate);
        if ($scope.govProcess.EndDate) $scope.govProcess.EndDate = moment($scope.govProcess.EndDate);
        if ($scope.govProcess.Deadline) $scope.govProcess.Deadline = moment($scope.govProcess.Deadline);

        // Page is dirty
        $scope.pageIsDirty = function () {
            $rootScope.$broadcast('page-is-dirty');
        };
        $scope.pageIsNotDirty = function () {
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // When in Create Mode
        if (_.isUndefined(governanceProcess.GovernanceProcessID)) {
            $scope.govProcess.FiscalYearID = fiscalYears[0].FiscalYearID;
            $scope.govProcess.ShortName = fiscalYears[0].Name;

            $scope.govProcess.GovernanceProcessTypeID = govProcessType.GovernanceProcessTypeID;

            $scope.pageIsDirty();
        }


        // Toggle Is Active
        $scope.toggleIsActive = function () {
            $scope.govProcess.IsActive = !$scope.govProcess.IsActive;
            $scope.pageIsDirty();
        };

        // Create Process
        $scope.createProcess = function () {
            if ($scope.isSubmitting) {
                return;
            }

            $scope.isSubmitting = true;

            travelService
                .createGovernanceProcess($scope.govProcess)
                .then(function () {
                    $state.go('travel.governanceProcessActive', {}, { reload: true });
                })
                .finally(function () {
                    $scope.isSubmitting = false;
                });
        };

        // Update Process
        $scope.updateProcess = function () {
            if ($scope.isSubmitting) {
                return;
            }

            $scope.isSubmitting = true;

            travelService
                .updateGovernanceProcess($scope.govProcess)
                .then(function () {
                    $state.go('travel.governanceProcessActive', {}, { reload: true });
                })
                .finally(function () {
                    $scope.isSubmitting = false;
                });
        };
    }
})();
